import { render, staticRenderFns } from "./toolSoftware.vue?vue&type=template&id=355b433a"
import script from "./toolSoftware.vue?vue&type=script&lang=js"
export * from "./toolSoftware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports